import React from "react";
import { FiArrowRight } from "react-icons/fi";
import RatingStars from "../common/RatingStars";
import Button from "../common/Button";

const reviews = [
  {
    quote: "The smoked paprika smells like the jar was opened beside a wood fire. It changed a simple pot of beans.",
    name: "Mara K.",
    detail: "Verified pantry customer",
  },
  {
    quote: "Finally, cardamom that is green, fragrant, and useful—not a dusty afterthought in the cupboard.",
    name: "Theo R.",
    detail: "Verified pantry customer",
  },
  {
    quote: "Every description tells me what the spice actually tastes like and what to cook. Beautiful and practical.",
    name: "Alicia D.",
    detail: "Verified pantry customer",
  },
];

const ReviewStrip = () => (
  <section className="section review-strip">
    <div className="site-container">
      <header className="section-heading section-heading--split">
        <div>
          <p className="eyebrow">Pantry notes</p>
          <h2>Loved by curious cooks</h2>
        </div>
        <Button to="/reviews" variant="text">Read all reviews <FiArrowRight aria-hidden="true" /></Button>
      </header>
      <div className="review-strip__grid">
        {reviews.map((review) => (
          <figure className="review-quote" key={review.name}>
            <RatingStars rating={5} />
            <blockquote>“{review.quote}”</blockquote>
            <figcaption><strong>{review.name}</strong><span>{review.detail}</span></figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export { reviews };
export default ReviewStrip;
